import { checkIsFreemiumPlan } from 'helper/checkPlan.helper';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { PermissionTypes } from './constants';
import PermissionInfoPage from './PermissionInfo';

const PermisssionViewValidationWrapper = ({ pageName, children, isNotNavigate, showPermissionInfo }) => {
    const { pagePermissions } = useSelector((state) => state.authentication);
    const { companyData } = useSelector((state) => state.customization);
    const navigate = useNavigate();

    const doUserHaveViewPermision = () => {
        const foundItem = pagePermissions?.[pageName];
        if (!foundItem?.hasViewPermission) {
            if (!isNotNavigate) navigate('/dashboard');
            return false;
        } else {
            if (
                checkIsFreemiumPlan(companyData?.subscription?.plan) &&
                [PermissionTypes.diologIntegration, PermissionTypes.webform, PermissionTypes.emailExtension].includes(pageName)
            ) {
                if (!isNotNavigate) navigate('/dashboard');
                return false;
            } else {
                return true;
            }
        }
    };
    const hasViewPermissionForThisPage = doUserHaveViewPermision();

    return hasViewPermissionForThisPage ? children : showPermissionInfo && !hasViewPermissionForThisPage ? <PermissionInfoPage /> : null;
};
export default PermisssionViewValidationWrapper;
